


const FAQData = [
    {
      question: "What is this website?",
      answer: "ChessThread is an interactive social platform dedicated entirely to chess. You can upload, customize, and share your own games, lessons, and puzzles with the community. Other players can view your posts, analyze positions with you, leave comments, and engage socially right on the chessboard. It’s designed to feel like a scrollable chess feed where every post is a chance to learn, play, or connect."
    },
    {
      question: "What's the best way to create a post?",
      answer: "Click on the [+] button to open the interactive analysis board. From there, you can make moves directly on the board or upload a PGN file to generate the Main Line. Enhance your post by adding variations, annotations, arrows, and marking favourite moves. Once complete, click *Save & Share* to publish your creation to the community feed. If you just want to analyze privately, you can stop without sharing."
    },
    {
      question: "How do I create a puzzle?",
      answer: "Click Create a Puzzle to open the puzzle editor. You can either set up the board manually or paste a FEN using the Load Position option. From there, make the solution moves yourself or use Stockfish to generate the line. Puzzles always use a single main line. Once ready, click Save & Share to publish it."
    },
    {
      question: "How do I engage with content on ChessThread?",
      answer: "Scroll through the feed to discover games, lessons, and puzzles shared by others. You can learn by replaying their moves, trying out your own variations directly on the board, and joining the conversation by leaving comments or feedback on their posts. You can also follow other users on the platform to see their posts in the Following tab."
    },
 
    {
      question: "How can I contribute to the platform?",
      answer: "Contribute by sharing your own games and engaging with the community. Support newer players by giving constructive comments on their games, suggesting ideas, and encouraging their progress. You can also like, share, or follow quality content, and if needed, dislike or report inappropriate posts."
      // Upgrading to Premium helps but is not required.
    },
    // {
    //   question: "How can I share to other social media platforms?",
    //   answer: "Click the share icon on any post to copy a link. Anyone can view without logging in. "
    //   // Premium users also get access to high-quality video sharing for expanded sharing options.
    // },
    {
      question: "Can I use Stockfish?",
      answer: "Yes. Stockfish is accessible by clicking the Robot icon beneath the board." 
      // However, to access Stockfish on others' shared games, you must be a Premium subscriber. A detailed Game Review feature is also coming soon.
    },
    {
      question: "Is the platform free to use?",
      answer: "Yes. All features are free, with optional premium features to come soon."
    },
    {
      question: "How can I follow other players?",
      answer: "Search for a user or click on any username to visit their profile, then click 'Follow'. More direct social features are on the way."
    },
    {
      question: "Do you offer private or unlisted posts?",
      answer: "No. Currently, all posts are public. We are working on a private posting feature."
    },
    {
      question: "How do I report inappropriate content?",
      answer: "Click 'Dislike' on the post or 'Report' on the comment. Our team will review it."
    },
    // {
    //   question: "How do I manage my subscription?",
    //   answer: "Go to the side Navigation Menu > Settings > Billing to view, change, or cancel Premium plans."
    // },
    {
      question: "How do I contact support?",
      answer: "Go to Settings > Contact for ways to reach our team."
    },
  ];

  export default FAQData;   